<template>
  <MyOrdersCard footer-class="pb-100" :to="`/my-orders/single-order/${orderId}`">
    <template #header>
      <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
    </template>

    <template #header-end>
      <slot name="header" />
    </template>

    <template #list>
      <IconListItemId :id="orderId" />

      <MyOrdersListItemPlay
        v-bind="{ lotteryId, numberOfExtraHitPlays, numberOfPlays }"
        :add-ons="selectedAddOns"
      />

      <IconListItemDate v-bind="{ date }" :label="$t('myorders.listitem.date.label')" />
    </template>

    <template #replay-button>
      <MyOrdersReplayButton
        v-if="isReplayable"
        v-bind="{ lotteryId, playSlipOrderId: id }"
        class="py-none px-400"
        size="small"
        @click.stop.prevent
      />
    </template>

    <template #cta>
      {{ $t('myorders.card.singleorder.cta') }}
    </template>
  </MyOrdersCard>
</template>

<script lang="ts" setup>
import type { PlaySlipOrder } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersSingleOrderCardProps = {
  date: Date | string
  id: PlaySlipOrder['id']
  licensedTerritory: PlaySlipOrder['licensedTerritory']
  lotteryId: PlaySlipOrder['lotteryId']
  numberOfExtraHitPlays: PlaySlipOrder['numberOfExtraHitPlays']
  numberOfPlays: PlaySlipOrder['numberOfPlays']
  orderId: PlaySlipOrder['orderId']
  replayable: PlaySlipOrder['replayable']
  selectedAddOns: PlaySlipOrder['selectedAddOns']
  status: PlaySlipOrder['status']
}

const props = defineProps<MyOrdersSingleOrderCardProps>()

const isReplayable = computed(() => canReplayLotteryOrder(props))
</script>
